import React from 'react';
interface TestimonialProps {
  quote: string;
  author: string;
  role: string;
  company?: string;
  photoUrl?: string;
}
export function Testimonial({
  quote,
  author,
  role,
  company,
  photoUrl
}: TestimonialProps) {
  return <div className="bg-gradient-to-br from-blue-50 to-slate-50 rounded-2xl p-8 md:p-12 border border-blue-100 print:border-2 print:border-blue-600 print:bg-blue-50" data-id="element-69">
      <div className="max-w-4xl mx-auto" data-id="element-70">
        {/* Quote mark */}
        <div className="text-6xl md:text-7xl text-blue-600 font-serif leading-none mb-4 print:text-blue-600" data-id="element-71">
          "
        </div>

        {/* Quote text */}
        <blockquote className="text-xl md:text-2xl font-light leading-relaxed text-slate-800 mb-8 print:text-black print:text-lg" data-id="element-72">
          {quote}
        </blockquote>

        {/* Attribution */}
        <div className="flex items-center gap-4 pt-6 border-t border-blue-200 print:border-blue-600" data-id="element-73">
          {photoUrl && <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-blue-200 print:ring-blue-600 print:grayscale" data-id="element-74">
              <img src={photoUrl} alt={author} className="w-full h-full object-cover" data-id="element-75" />
            </div>}
          <div data-id="element-76">
            <div className="font-semibold text-lg text-slate-900 print:text-black" data-id="element-77">
              {author}
            </div>
            <div className="text-slate-600 print:text-slate-800" data-id="element-78">
              {role}
              {company && <>
                  {' '}
                  <span className="text-slate-400 print:text-slate-600" data-id="element-79">
                    @
                  </span>{' '}
                  <span className="font-medium text-slate-700 print:text-black" data-id="element-80">
                    {company}
                  </span>
                </>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}